import { useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { DollarSign, Users, Clock, Award } from "lucide-react";
import { analytics, ANALYTICS_EVENTS } from "@/lib/analytics";

const reportCards = [
  {
    title: "Spend Report",
    description: "Analyze your procurement spending patterns, budget utilization, and cost trends over time.",
    icon: DollarSign,
    href: "/reports/spend",
    color: "text-emerald-500",
    bgColor: "bg-emerald-500/10",
  },
  {
    title: "Vendors Report",
    description: "Review vendor performance, engagement metrics, and relationship analytics.",
    icon: Users,
    href: "/reports/vendors",
    color: "text-blue-500",
    bgColor: "bg-blue-500/10",
  },
  {
    title: "Cycle Times Report",
    description: "Track procurement cycle times, identify bottlenecks, and measure process efficiency.",
    icon: Clock,
    href: "/reports/cycle-times",
    color: "text-amber-500",
    bgColor: "bg-amber-500/10",
  },
  {
    title: "Diversity Report",
    description: "Monitor diversity spend, track supplier diversity goals, and analyze certification distribution.",
    icon: Award,
    href: "/reports/diversity",
    color: "text-purple-500",
    bgColor: "bg-purple-500/10",
  },
];

export default function ReportsPage() {
  // Track report page viewed
  useEffect(() => {
    analytics.track({
      name: ANALYTICS_EVENTS.REPORT_VIEWED,
      category: 'engagement',
      properties: {
        report_type: 'reports_index',
      },
    });
  }, []);

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Reports</h1>
        <p className="text-muted-foreground mt-2">
          Access insights and analytics to make data-driven procurement decisions.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {reportCards.map((report) => {
          const Icon = report.icon;
          return (
            <Link key={report.href} to={report.href}>
              <Card className="h-full transition-all hover:shadow-md hover:border-primary/50 cursor-pointer">
                <CardHeader className="flex flex-row items-start gap-4">
                  <div className={`p-3 rounded-lg ${report.bgColor}`}>
                    <Icon className={`h-6 w-6 ${report.color}`} />
                  </div>
                  <div className="space-y-1">
                    <CardTitle className="text-xl">{report.title}</CardTitle>
                    <CardDescription className="text-sm">
                      {report.description}
                    </CardDescription>
                  </div>
                </CardHeader>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
